import { GraphQLClient } from "graphql-request";
import { store } from ".";

export const client = async (query: string, variables?: any) => {
  if (!window.Shopify.shop) return null;

  if (!store) {
    console.error("No store found in config")
    return null;
  }

  const graphQLClient = new GraphQLClient(
    `https://${
      store.shopify_domain
    }.myshopify.com/api/${store.storefront_version}/graphql`,
    {
      headers: {
        "X-Shopify-Storefront-Access-Token":
          store.storefront_access_token,
      },
    }
  );
  return await graphQLClient.request(query, variables);
};
